/* =========================================================
   Video + Anlatım ve Görsel Şeridi bölümleri.
   - dış video: tıklanınca iframe basılır, o ana kadar hiç yüklenmez
   - yatay şerit: ok düğmeleri, kayacak içerik yoksa gizlenir
   Event-delegated: bölüm sonradan DOM'a girse de çalışır.
   ========================================================= */
(function () {
  "use strict";

  var EMBEDS = {
    youtube: "https://www.youtube-nocookie.com/embed/{id}?autoplay=1&rel=0",
    vimeo: "https://player.vimeo.com/video/{id}?autoplay=1"
  };

  document.addEventListener("click", function (e) {
    var facade = e.target.closest ? e.target.closest("[data-video-facade]") : null;
    if (!facade) return;
    var id = facade.getAttribute("data-embed");
    var type = facade.getAttribute("data-type");
    var pattern = EMBEDS[type];
    if (!id || !pattern) return;

    var frame = document.createElement("iframe");
    frame.src = pattern.replace("{id}", encodeURIComponent(id));
    frame.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
    frame.setAttribute("allowfullscreen", "");
    frame.setAttribute("title", facade.getAttribute("aria-label") || "");
    frame.className = "media-text__frame";
    facade.replaceWith(frame);
  });

  /* ---------- Yatay şerit okları ---------- */
  function syncArrows(root) {
    var strip = root.querySelector("[data-hscroll-strip]");
    var prev = root.querySelector("[data-hscroll-prev]");
    var next = root.querySelector("[data-hscroll-next]");
    if (!strip || !prev || !next) return;
    root.classList.toggle("is-scrollable", strip.scrollWidth > strip.clientWidth + 2);
    prev.disabled = strip.scrollLeft <= 2;
    next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
  }

  function initStrip(root) {
    if (root.hasAttribute("data-hscroll-ready")) return;
    root.setAttribute("data-hscroll-ready", "");
    var strip = root.querySelector("[data-hscroll-strip]");
    if (!strip) return;
    var sync = function () { syncArrows(root); };
    sync();
    strip.addEventListener("scroll", sync, { passive: true });
    /* Görseller geç yüklenince scrollWidth büyüyor; ResizeObserver onu yakalar */
    if (window.ResizeObserver) new ResizeObserver(sync).observe(strip);
    else window.addEventListener("resize", sync);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-hscroll-prev], [data-hscroll-next]") : null;
    if (!btn) return;
    var root = btn.closest("[data-hscroll]");
    var strip = root && root.querySelector("[data-hscroll-strip]");
    if (!strip) return;
    var step = Math.max(240, Math.round(strip.clientWidth * 0.8));
    strip.scrollBy({ left: btn.hasAttribute("data-hscroll-next") ? step : -step, behavior: "smooth" });
  });

  function initAll() {
    document.querySelectorAll("[data-hscroll]").forEach(initStrip);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();

  /* Tema düzenleyicide bölüm eklenip çıkarılınca yeniden bağla */
  document.addEventListener("shopify:section:load", initAll);
})();
